import Loading from "@components/loading/index.jsx";
import { Button, Col, Form, Input, Row } from "antd";
import React from "react";
import LimitsPeriodToggle from "../LimitsPeriodToggle";
import LimitsResultsTable from "../LimitsResultsTable";
import { LIMIT_TYPE_I18N_KEYS } from "../../constants";
import {
	BackofficeHint,
	ContentDivider,
	ControlsPanel,
	ControlsRow,
	ErrorText,
	FormWrapper,
	MessageSlot,
	MessagesArea,
	PendingBanner,
	RemoveButton,
	RemoveButtonSlot,
	SectionCard,
	SectionHeader,
	SectionTitle,
} from "./elements";
import useController from "./useController";

const LimitsLimitSection = ({ type, limits, currency, translate, showAlert, isLoading }) => {
	const { state, handlers, helpers } = useController({
		type,
		limits,
		currency,
		translate,
		showAlert,
	});

	if (isLoading) {
		return (
			<SectionCard>
				<Loading loading />
			</SectionCard>
		);
	}

	return (
		<SectionCard>
			<SectionHeader>
				<SectionTitle>{translate(LIMIT_TYPE_I18N_KEYS[type])}</SectionTitle>
				<ControlsPanel>
					<ControlsRow>
						<LimitsPeriodToggle
							value={state.period}
							onChange={handlers.setPeriod}
							translate={translate}
							disabled={state.isFormDisabled}
						/>
					</ControlsRow>
				</ControlsPanel>
			</SectionHeader>

			<MessagesArea>
				<MessageSlot $visible={Boolean(state.pendingText)}>
					{state.pendingText ? <PendingBanner>{state.pendingText}</PendingBanner> : null}
				</MessageSlot>
				<MessageSlot $visible={Boolean(state.backofficeHint)}>
					{state.backofficeHint ? <BackofficeHint>{state.backofficeHint}</BackofficeHint> : null}
				</MessageSlot>
				<MessageSlot $visible={Boolean(state.formError)}>
					{state.formError ? <ErrorText>{state.formError}</ErrorText> : null}
				</MessageSlot>
			</MessagesArea>

			<FormWrapper>
				<Form
					form={helpers.form}
					onFinish={handlers.handleSetLimit}
					layout="vertical">
					<Row
						gutter={[10, 10]}
						align="bottom">
						<Col
							xs={24}
							md={12}>
							<Form.Item
								label={state.inputLabel}
								name="value">
								<Input
									type="number"
									min={1}
									step={state.isAmountType ? "0.01" : "1"}
									placeholder={state.inputPlaceholder}
									disabled={state.isFormDisabled}
								/>
							</Form.Item>
						</Col>
						<Col
							xs={12}
							md={6}>
							<Form.Item>
								<Button
									htmlType="submit"
									className="two-factor-auth-exclude-btn"
									loading={state.isSetting}
									disabled={state.isFormDisabled}>
									{state.limit?.userMax
										? translate("limits.updateLimit")
										: translate("limits.setLimit")}
								</Button>
							</Form.Item>
						</Col>
						<Col
							xs={12}
							md={6}>
							<RemoveButtonSlot>
								<RemoveButton
									type="button"
									disabled={state.isFormDisabled || !state.canRemove}
									onClick={handlers.handleRemoveLimit}
									aria-hidden={!state.canRemove}>
									{state.isDeleting
										? translate("limits.removing")
										: translate("limits.removeLimit")}
								</RemoveButton>
							</RemoveButtonSlot>
						</Col>
					</Row>
				</Form>
			</FormWrapper>

			<ContentDivider />

			<LimitsResultsTable
				translate={translate}
				rows={state.tableRows}
				selectedPeriod={state.period}
			/>
		</SectionCard>
	);
};

export default LimitsLimitSection;
